export const IS_LOADER_ACTIVE = 'IS_LOADER_ACTIVE'
export const SET_COMMON_PROP = 'SET_COMMON_PROP'
export const INIT_SAGA = 'INIT_SAGA'
export const CLOSE_MODAL_ON_VIEW_DETAILS = 'CLOSE_MODAL_ON_VIEW_DETAILS'